import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { POSTS } from "./blog";
import { PRODUCTS } from "./shop";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Ctx = createContext({ posts: POSTS, products: PRODUCTS, loaded: false });

const load = async (path, fallback) => {
  try {
    const { data } = await axios.get(`${API}${path}`);
    return Array.isArray(data) && data.length ? data : fallback;
  } catch {
    return fallback;
  }
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({ posts: POSTS, products: PRODUCTS, loaded: false });
  useEffect(() => {
    let alive = true;
    Promise.all([load("/content/posts", POSTS), load("/content/products", PRODUCTS)]).then(([posts, products]) => {
      if (alive) setContent({ posts, products, loaded: true });
    });
    return () => { alive = false; };
  }, []);
  return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
};

export const usePosts = () => useContext(Ctx).posts;
export const useProducts = () => useContext(Ctx).products;
export const useContentLoaded = () => useContext(Ctx).loaded;
export const categoriesOf = (posts) => ["Tutti", ...Array.from(new Set(posts.map((p) => p.category)))];
